<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
  import './assets/css/common.css'
  export default {
    name: "App",
    provide() {
      return {
        reload: this.reload,
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    },
    components: {},
    created() {
       
      if (localStorage.getItem('store')) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))));
      }
      // 在页面刷新时将vuex里的信息保存到localStorage里
      // this.$store.dispatch('setMbjdtime',JSON.stringify({type:3}))
      window.addEventListener('pagehide', () => {
        localStorage.setItem('store', JSON.stringify(this.$store.state));
      });

      // 在登录和注销界面增加
      // localStorage.removeItem('store');
      
    },
    mounted() {
      let that = this
      //  window.onload = function () {
      //   if (!window.sessionStorage["token"]) {

      //       that.$store.dispatch('LogOut').then(() => {
      //         location.reload() // 为了重新实例化vue-router对象 避免bug
      //       })
      //   } else {
      //     // 刷新
      //   }
        
      // };
      // window.onunload = function () {
      //   window.sessionStorage["token"] = true;
      // };
      // window.onbeforeunload = function () {
      //   window.sessionStorage["token"] = true;
      // };
      
    },
   
  };
</script>

<style>
  #app{
    color: #000000;
    font-size: 14px;
  }
  .common-head{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .common-head .head-left{
    display: flex;
    align-items: center;
  }
  .common-head .head-left span{
    margin: 0 8px;
  }
  .common-head .head-left .switch-item{
    margin-bottom: 0;
    margin-left: 6px;
  }
  .common-head .head-left .el-select{
    width: 120px;
  }
  .common-head .head-right{
    display: flex;
    align-items: center;
  }
  .common-head .head-right .head-switch{
    margin-left: 16px;
    margin-right: 8px;
  }
  .echart-box:not(:last-child),.echarts-box:not(:last-child){
    margin-bottom: 24px;
  }
  .p14{
    font-size: 14px!important;
  }
  .analysis-box,.echart-box,.echarts-box,.eachrt-box{
    background-color: #d7ded2;
    padding: 24px;
  }
  .mini{
    width: 120px;
    margin-left: 10px;
  }
  .common-head{
    margin-bottom: 20px;
  }
  .el-table >>> .headerClass th{
    background: #737eae !important;
    color: #fff;
    padding: 3px 0;
  }
  .marker-cluster-small div,
  .marker-cluster-small,
  .marker-cluster-medium,
  .marker-cluster-medium div,
  .marker-cluster-large,
  .marker-cluster-large div{
    background: transparent !important;
    display: none !important;
  }
  .my-div-icon{
    text-shadow: #fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0, #fff 0 -1px 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue